import { withBlockExtensions } from '@plone/volto/helpers';
import cx from 'classnames';
const IframeView = (props) => {
  const { className, data } = props;
  if (!data) return null;
  const target = data.url;
  if (!target) return null;

  return (
    <section className={cx('item', 'junts-iframe', className)}>
      <iframe src={target} title={target} />
    </section>
  );
};

export default withBlockExtensions(IframeView);
